import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import GroupsIcon from "@mui/icons-material/Groups";
import { Button, Tooltip } from "@mui/material";

const Action = ({
  row,
  handleOpenModal,
  icon,
  variant,
  title,
  style,
  btnColor,
  isDisabled = false,
}) => {
  return (
    <Tooltip title={title} placement="top">
      <span>
        <Button
          variant={variant}
          onClick={handleOpenModal}
          style={{ marginRight: "8px", ...style }}
          color={btnColor}
          disabled={isDisabled}
        >
          {icon}
        </Button>
      </span>
    </Tooltip>
  );
};

export default Action;
